import { useState } from "react";
import { makeStyles, Grid, Typography, Box } from "@material-ui/core";

import { DialogBox } from "../../components/boxes";
import { Dialog, TextInput, Icon, TextButton, Button } from "../../components/base";
import CloseIcon from "../../assets/images/modals/CloseModal.svg";

import { COLORS } from "../../theme/colors";
import {
  ATLEAST_ONE_UPPERCASE,
  MAX_PASS_CHAR_COUNT,
  MIN_PASS_CHAR_COUNT,
  postData,
  SPECIAL_CHARACTER,
} from "../../services";
import endPoints from "../../services/apiEndPoints";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 520,
    height: 295,
  },
  closeIcon: {
    marginTop: 10,
  },
  heading: {
    fontWeight: 700,
    color: COLORS.darks[0][100],
    fontSize: 24,
  },
  groupBtn: {
    marginTop: theme.spacing(3),
  },
  iconWrapper: {
    height: 25,
    marginLeft: 500,
    marginTop: "-45px",
  },
  labelStyle: {
    color: COLORS.grayShade,
  },
  initial: {
    height: 2,
    background: COLORS.silver,
    width: "33%",
  },
  weak: {
    height: 2,
    background: COLORS.red,
    width: "33%",
  },
  medium: {
    height: 2,
    background: COLORS.orange,
    width: "33%",
  },
  strong: {
    height: 2,
    background: COLORS.green,
    width: "33%",
  },
  strText: {
    fontWeight: 700,
  },
}));

export const ChangePasswordModal = ({ isOpen, setOpen, setShowSuccessModal }) => {
  const classes = useStyles();

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [strength, setStrength] = useState("initial");
  const [isPasswordValidate, setPasswordValidate] = useState({
    currentPassword: false,
    newPassword: false,
  });

  const handleChange = () => {
    const token = localStorage.getItem("ACCESS_TOKEN");
    setErrors({});
    const errors = {};
    if (!currentPassword) {
      errors["currentPassword"] = "Password Should Not Be Empty";
    }
    if (!(password === rePassword)) {
      errors["rePassword"] = "Password Does Not Match";
    }
    if (!SPECIAL_CHARACTER.test(password)) {
      errors["password"] = "Password Should Contain Special Character";
    }
    if (!ATLEAST_ONE_UPPERCASE.test(password)) {
      errors["password"] = "Password Should Contain Atleast One Upper Case Character";
    }
    if (!(password.length >= MIN_PASS_CHAR_COUNT && password.length <= MAX_PASS_CHAR_COUNT)) {
      errors["password"] = "Password should contain 8-20 characters";
    }
    if (!password) {
      errors["password"] = "Please enter Password";
    }
    if (!rePassword) {
      errors["rePassword"] = "Please Re-Enter Your Password";
    }
    if (password === currentPassword) {
      errors["password"] = "New Password Should Not Be Same As Old Password";
    }

    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }
    setLoading(true);
    postData(
      endPoints.CHANGE_PASSWORD,
      (data) => {
        setOpen(false);
        setShowSuccessModal(true);
        setErrors({ currentPassword: data.error });
      },
      {
        token: token,
        password: password,
      }
    ).catch((e) => console.log(e));
  };

  const handleChanges = (password) => {
    setPassword(password);
    if (
      SPECIAL_CHARACTER.test(password) &&
      ATLEAST_ONE_UPPERCASE.test(password) &&
      password.length >= MIN_PASS_CHAR_COUNT &&
      password.length <= MAX_PASS_CHAR_COUNT
    ) {
      setStrength("strong");
      setPasswordValidate({ ...isPasswordValidate, newPassword: true });
    } else if (
      (ATLEAST_ONE_UPPERCASE.test(password) || SPECIAL_CHARACTER.test(password)) &&
      password.length >= 6
    ) {
      setStrength("medium");
    } else if (password.length >= 1) {
      setStrength("weak");
    } else setStrength("initial");
  };

  const checkCurrentPassword = () => {
    const token = localStorage.getItem("ACCESS_TOKEN");
    setErrors({});
    postData(
      endPoints.VALIDATE_PASSWORD,
      (data) => {
        setPasswordValidate({
          ...isPasswordValidate,
          currentPassword: true,
        });
        setErrors({ currentPassword: data.error });
      },
      {
        token: token,
        password: currentPassword,
      }
    ).catch((e) => console.log(e));
  };

  return (
    <Dialog isOpen={isOpen} onClose={() => setOpen(false)}>
      <DialogBox>
        <Grid
          item
          xs={8}
          className={classes.closeIcon}
          container
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography className={classes.heading}>Change Password</Typography>
          <Icon
            root={classes.iconWrapper}
            src={CloseIcon}
            hoverable
            tooltip="Close"
            onClick={() => setOpen(false)}
          />
          <TextInput
            id="current-password"
            type="password"
            fullWidth
            label="Current password"
            onChange={(v) => setCurrentPassword(v)}
            value={currentPassword}
            onFocus={() => setErrors({ ...errors, currentPassword: null })}
            error={errors.currentPassword}
            labelRoot={classes.labelStyle}
            onBlur={() => checkCurrentPassword()}
          />
          <TextInput
            id="new-password"
            type="password"
            fullWidth
            label="New password"
            onChange={(v) => handleChanges(v)}
            value={password}
            onFocus={() => setErrors({ ...errors, password: null })}
            error={errors.password}
            labelRoot={classes.labelStyle}
          />
          {password && (
            <Box style={{ display: "flex", width: "70%" }}>
              {strength == "weak" && (
                <>
                  <Box className={classes.weak}></Box>
                  <Box className={classes.initial}></Box>
                  <Box className={classes.initial}></Box>
                </>
              )}
              {strength == "medium" && (
                <>
                  <Box className={classes.medium}></Box>
                  <Box className={classes.medium}></Box>
                  <Box className={classes.initial}></Box>
                </>
              )}
              {strength == "strong" && (
                <>
                  <Box className={classes.strong}></Box>
                  <Box className={classes.strong}></Box>
                  <Box className={classes.strong}></Box>
                </>
              )}
            </Box>
          )}
          {password && (
            <Box style={{ width: "70%", marginTop: 5 }}>
              <span>password strength : </span>
              <span
                className={classes.strText}
                style={
                  strength == "weak"
                    ? { color: "red" }
                    : strength == "medium"
                    ? { color: "orange" }
                    : { color: "green" }
                }
              >
                {strength}
              </span>
            </Box>
          )}
          <TextInput
            id="confirm-password"
            type="password"
            fullWidth
            label="Confirm password"
            onChange={(v) => setRePassword(v)}
            value={rePassword}
            onFocus={() => setErrors({ ...errors, rePassword: null })}
            error={errors.rePassword}
            labelRoot={classes.labelStyle}
          />
        </Grid>
        <Grid className={classes.groupBtn} container alignItems="center">
          <Button
            id="update-password-button"
            text="UPDATE PASSWORD"
            onClick={handleChange}
            loading={loading}
            disabled={strength !== "strong"}
          />
          <TextButton
            text="CANCEL"
            normalFontWeight
            style={{ marginLeft: 30 }}
            onClick={() => setOpen(false)}
          />
        </Grid>
      </DialogBox>
    </Dialog>
  );
};
